import React, { useState, useMemo } from "react";
import CustomTabs from "components/tabs/customTab";
import TicketFilter from "./TicketFilter";
import TicketCard from "./TicketCard";
import { tickets } from "./Tickets";
import NoTickets from "./NoTickets";
import GridCard from "./CategoryGridCard";
import { Building2, Handshake } from "lucide-react";

const SupportTabs = () => {
    const [activeTab, setActiveTab] = useState("tickets");

    const [searchQuery, setSearchQuery] = useState("");
    const [categoryFilter, setCategoryFilter] = useState(0); 
    const [statusFilter, setStatusFilter] = useState(0);     
    
    const TabLabel = ({ icon: Icon, text }) => (
        <div className="flex items-center justify-center gap-2">
            <Icon className="text-gray-800 w-4 h-4" />
            <span className="text-sm font-medium">{text}</span>
        </div>
    );

    const tabOptions = [
        { label: <TabLabel icon={Handshake} text="My Tickets (5)" />, value: "tickets" },
        { label: <TabLabel icon={Building2} text="Services" />, value: "services" },
    ];

    const categoryOptions = [
        { label: "All Categories", value: 0 },
        { label: "Billing", value: 1 },
        { label: "Contracts", value: 2 },
        { label: "Service", value: 3 },
        { label: "Partnerships", value: 4 },
        { label: "Support", value: 5 },
    ];

    const statusOptions = [
        { label: "All Status", value: 0 },
        { label: "Open", value: 1 },
        { label: "In-progress", value: 2 },
        { label: "Resolved", value: 3 },
    ];

    const handleSearchChange = ({ keyword }) => {
        setSearchQuery(keyword || "");
    };

    const filteredTickets = useMemo(() => {
        return tickets.filter((ticket) => {
        const matchesSearch =
            ticket.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
            ticket.description.toLowerCase().includes(searchQuery.toLowerCase());

        const matchesCategory =
            categoryFilter === 0 ||
            ticket.category === categoryOptions.find((opt) => opt.value === categoryFilter)?.label;

        const matchesStatus =
            statusFilter === 0 ||
            ticket.status === statusOptions.find((opt) => opt.value === statusFilter)?.label;

        return matchesSearch && matchesCategory && matchesStatus;
        });
    }, [searchQuery, categoryFilter, statusFilter]);

    console.log(TicketCard);

    return (
        <div className="flex flex-col gap-2 space-y-6">
            <CustomTabs
                tabs={tabOptions}
                activeTab={activeTab}
                onChange={setActiveTab}
            />

            <>
                {activeTab === "tickets" && (
                    <div className="flex-1 outline-none space-y-6">
                        <TicketFilter
                            searchQuery={searchQuery}
                            onSearchChange={handleSearchChange}
                            category={categoryFilter}
                            onCategoryChange={setCategoryFilter}
                            status={statusFilter}
                            onStatusChange={setStatusFilter}
                            categoryOptions={categoryOptions}
                            statusOptions={statusOptions}
                        />
                        {filteredTickets.map((ticket) => (
                            <TicketCard key={ticket.id} ticket={ticket} />
                        ))}

                        {filteredTickets.length === 0 && (
                            <NoTickets />
                        )}
                    </div>
                )}

                {activeTab === "services" && (
                    <GridCard tickets={tickets}/>
                )}
            </>
        </div>
    );
};

export default SupportTabs;
